<template>
	<v-text-field
		:label="label"
		autocomplete="off"
		:readonly="readonly"
		:required="required"
		:disabled="disabled"
		:clearable="clearable"
		:suffix="suffix"
		:prepend-icon="prependIcon"
		:prepend-inner-icon="prependInnerIcon"
		:loading="loading"
		:rules="allRules"
		:solo="solo"
		:filled="filled"
		:flat="flat"
		:outline="outline"
		:name="name"
		:value="value"
		:hint="hint"
		@input="onInput"
		@focusin="onFocusin"
		@change="onChange">
	</v-text-field>
</template>
<style scoped>
</style>

<script>
	import {toNum, toStr} from '../../js/common'

	export default {
		props: {
			label: String,
			value: [String, Number],
			readonly: Boolean,
			disabled: Boolean,
			required: Boolean,
			clearable: Boolean,
			loading: Boolean,
			solo: Boolean,
			filled: Boolean,
			outline: Boolean,
			flat: Boolean,
			suffix: String,
			prependIcon: String,
			prependInnerIcon: String,
			name: String,
			hint: String,
			align: String,
			rules: Array,
			digits: {
				type: [String, Number],
				default: 2
			}
		},
		computed: {
			allRules() {
				const rules = this.rules || []

				if (this.required) {
					var rule =
						v => !!v || 'Введите значение'

					rules.push(rule)
				}

				// console.log(rules)

				return rules
			},
		},
		data: () => ({
		}),
		methods: {
			format: function (val) {
				// console.log('format ' + val)
				if (val == '' || !val) return val

				val = val + ''
			    val = val.replace(/[^0-9+\-.,]/g, '')    // убираемся все не-цифры
			    val = val.replace(/,/g, '.')             // , заменяем на .
			    val = toStr(val, this.digits)
				return val
				// this.$emit('input', val)
			},
			unFormat: function (val) {
				// console.log('unformat ' + val)
				if (this.readonly || this.disabled) return val
				if (+val == 0) return ''
				val = val + ''
				val = val.replace(/\s/g, '')
				return val
			},
			onInput: function (e) {
				// console.log('onInput')
				// e = this.format(e)
				this.$emit('input', e)
			},
			onChange: function(e) {
				// console.log('onChange')
				e = this.format(e)
				this.$emit('input', e)
			},
			onFocusin: function(e) {
				let val = this.unFormat(this.value)
				this.$emit('input', val)
			}
			// format: function (e) {
			// 	console.log('format ' + this.value)
			// 	let val = this.value + ''
			//     val = val.replace(/[^0-9+\-.,]/g, '')    // убираемся все не-цифры
			//     val = val.replace(/,/g, '.')             // , заменяем на .
			//     val = toStr(val, this.digits)
			// 	this.$emit('input', val)
			// },
			// unFormat: function () {
			// 	console.log('unformat ' + this.value)
			// 	let val = this.value + ''
			// 	val = val.replace(/\s/g, '');
			// 	this.$emit('input', val)
			// },
			// onInput: function (e) {
			// 	console.log('onInput')
			// 	console.log(e)
			// 	this.$emit('input', e)
			// },
		}
	}
</script>
